import React from 'react';
import { TypographyVariant } from '../style/typography';
import Link from '../Link/Link';
import { SxProp } from '../style/sxProp';

type Props = {
  sx?: SxProp;
  className?: string;
  ['data-testid']?: string;
  'aria-label'?: string;
  variant?: TypographyVariant;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

// A wrapper around <Link> for usages where we want a button that's stylized as a link/anchor.
// TODO: the optimal solution here to use a <button> that's stylized as an anchor instead (jsx-a11y/anchor-is-valid).
const LinkButton: React.FC<Props> = (props) => {
  const { onClick, ...rest } = props;

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      // we need to add a placeholder href in order to enable accessibility features (tabbable and clickable via enter)
      href="#"
      onClick={(e) => {
        // Prevents href="#" from adding a new entry to the history stack
        e.preventDefault();
        onClick?.(e);
      }}
      {...rest}
    />
  );
};

export default LinkButton;
